import { Component, OnInit, Input} from '@angular/core';
import * as CONSTANTS  from '../../constants';
import  '../../js/MarketingClickStream.js';

declare var setClickStreamPropertiesForClick: any;
@Component({
  selector: 'pru-marketing-content-fields',
  templateUrl: './marketing-content-fields.component.html',
  styleUrls: ['./marketing-content-fields.component.scss']
})
export class MarketingContentFieldsComponent implements OnInit {

  constructor() { }
  @Input() columnContent:any;
  @Input() marketingTheme:string;
  @Input() shortTitlePresent : boolean;
  @Input() longTitlePresent : boolean;
  @Input() longShortTitle : boolean;
  @Input() preTitlePresent : boolean;
  @Input() contentId: string;
  @Input() retirementLink:string;
  preTitle1Present:boolean=false;
  pre_title1_text:string;
  pre_title1_url:string;
  pre_title1_urlAlt:string;
  pre_title1_target:string;
  pre_title1_iconUrl:string;
  pre_title1_iconText:string;
  pre_title1_iconCaption:string;
  pre_title1_iconAlign:string;
  hasPreTitle1UrlIcon:boolean = false;
  short_title_1:string;
  long_title_1:string;
  image_url:string;
  image_altText:string;
  image_caption:string;
  image_alignment:string;
  image_width:string;
  image_height:string;
  preTitle2Present:boolean=false;
  pre_title2_text:string;
  pre_title2_url:string;
  pre_title2_urlAlt:string;
  pre_title2_target:string;
  pre_title2_iconUrl:string;
  pre_title2_iconText:string;
  pre_title2_iconCaption:string;
  pre_title2_iconAlign:string;
  hasPreTitle2UrlIcon:boolean = false;
  short_title_2:string;
  long_title_2:string;
  date:string;
  readTime:string;
  author:string;
  postTitlePresent:boolean=false;
  post_title_text:string;
  post_title_url:string;
  post_title_urlAlt:string;
  post_title_target:string;
  post_title_iconUrl:string;
  post_title_iconText:string;
  post_title_iconCaption:string;
  post_title_iconAlign:string;
  hasPostTitleUrlIcon:boolean = false;
  text_1:string;
  text_1_para:string;
  text_2:string;
  bulletPoints:any[];
  subHeadingPresent:boolean=false;
  sub_heading_text:string;
  sub_heading_url:string;
  sub_heading_urlAlt:string;
  sub_heading_target:string;
  sub_heading_iconUrl:string;
  sub_heading_iconText:string;
  sub_heading_iconCaption:string;
  sub_heading_iconAlign:string;
  hasSubHeadingUrlIcon:boolean = false;
  sub_text:string;
  primaryButtonPresent:boolean=false;
  primary_button_text:string;
  primary_button_url:string;
  primary_button_urlAlt:string;
  primary_button_target:string;
  primary_button_iconUrl:string;
  primary_button_iconText:string;
  primary_button_iconCaption:string;
  primary_button_iconAlign:string;
  hasPrimaryButtonUrlIcon:boolean = false;
  secondaryButtonPresent:boolean=false;
  secondary_button_text:string;
  secondary_button_url:string;
  secondary_button_urlAlt:string;
  secondary_button_target:string;
  secondary_button_iconUrl:string;
  secondary_button_iconText:string;
  secondary_button_iconCaption:string;
  secondary_button_iconAlign:string;
  hasSecondaryButtonUrlIcon:boolean = false;
  post_text_html:string;
  primaryCTAPresent:boolean=false;
  primary_CTA_text:string;
  primary_CTA_url:string;
  primary_CTA_urlAlt:string;
  primary_CTA_target:string;
  primary_CTA_iconUrl:string;
  primary_CTA_iconText:string;
  primary_CTA_iconCaption:string;
  primary_CTA_iconAlign:string;
  hasPrimaryCTAUrlIcon:boolean = false;
  secondaryCTAPresent:boolean=false;
  secondary_CTA_text:string;
  secondary_CTA_url:string;
  secondary_CTA_urlAlt:string;
  secondary_CTA_target:string;
  secondary_CTA_iconUrl:string;
  secondary_CTA_iconText:string;
  secondary_CTA_iconCaption:string;
  secondary_CTA_iconAlign:string;
  hasSecondaryCTAUrlIcon:boolean = false;
  bufferContentPresent:boolean=false;
  buffer_heading:string;
  buffer_text:string;
  bufferContentButtonPresent:boolean=false;
  buffer_button_text:string;
  buffer_button_url:string;
  buffer_button_urlAlt:string;
  buffer_button_target:string;
  buffer_button_iconUrl:string;
  buffer_button_iconText:string;
  buffer_button_iconCaption:string;
  buffer_button_iconAlign:string;
  hasBufferButtonUrlIcon:boolean = false;
  bufferContentLinkPresent:boolean=false;
  buffer_link_text:string;
  buffer_link_url:string;
  buffer_link_urlAlt:string;
  buffer_link_target:string;
  buffer_link_iconUrl:string;
  buffer_link_iconText:string;
  buffer_link_iconCaption:string;
  buffer_link_iconAlign:string;
  hasBufferLinkUrlIcon:boolean = false;
  textColor:string;
  btnTypePrimary:string;
  btnTypeSecondary:string;
  themeCTATitle:string;
  paraTheme:string;
  ctaTheme:string;
  shortTitleTheme:string;
  longTitleTheme:string;
  hasContentAfterImage:boolean=false;

  ngOnInit() {
    this.getColumnFieldsFromJSON();
  }

  /*
    Retrieves column content fields for each marketing slot
  */ 
  getColumnFieldsFromJSON():void{
    
    this.getPreTitle1Details();
    this.short_title_1 = this.columnContent[CONSTANTS.SHORT_TITLE_1];
    this.long_title_1 = this.columnContent[CONSTANTS.LONG_TITLE_1];
    this.getImageDetails();
    this.getPreTitle2Details();
    this.short_title_2 = this.columnContent[CONSTANTS.SHORT_TITLE_2];
    this.long_title_2 = this.columnContent[CONSTANTS.LONG_TITLE_2];
    this.date = this.columnContent[CONSTANTS.DATE];
    this.readTime = this.columnContent[CONSTANTS.READ_TIME];
    this.author = this.columnContent[CONSTANTS.AUTHOR];
    this.getPostTitleDetails();
    this.text_1 = this.columnContent[CONSTANTS.TEXT_1];
    this.text_1_para = this.columnContent[CONSTANTS.TEXT_1_PARA];
    this.text_2 = this.columnContent[CONSTANTS.TEXT_2];
    this.bulletPoints = this.columnContent[CONSTANTS.BULLET_POINTS];
    this.getSubHeadingDetails();
    this.sub_text = this.columnContent[CONSTANTS.SUB_TEXT];
    this.post_text_html = this.columnContent[CONSTANTS.POST_TEXT_HTML];
    this.getPrimaryButtonDetails();
    this.getSecondaryButtonDetails();
    this.getPrimaryCTADetails();
    this.getSecondaryCTADetails();
    this.getBufferDetails();
    this.chooseThemeForPara(this.marketingTheme);
    this.chooseBtnTypeForPrimary(this.marketingTheme);
    this.chooseBtnTypeForSecondary(this.marketingTheme);
    this.chooseThemeForCTA(this.marketingTheme);
    this.chooseThemeForShortTitle(this.marketingTheme);
    this.chooseThemeForLongTitle(this.marketingTheme);
    this.checkIfContentExistAfterImage();
  }

  /*
  Retrieves PreTitle1 Details
  */ 
  getPreTitle1Details():void {
    if(this.columnContent[CONSTANTS.PRE_TITLE_1]!=null && this.columnContent[CONSTANTS.PRE_TITLE_1].length>0 ){
      this.preTitle1Present = true;
      this.pre_title1_text = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.TEXT];
      this.pre_title1_url = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.URL];
      this.pre_title1_urlAlt = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.URL_ALT];
      this.pre_title1_target = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.TARGET];
        if(this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.ICON]!= null &&
            this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.ICON].length>0){
            this.pre_title1_iconUrl = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
            this.pre_title1_iconText = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
            this.pre_title1_iconCaption = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
            this.pre_title1_iconAlign = this.columnContent[CONSTANTS.PRE_TITLE_1][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
            if(this.pre_title1_iconUrl != "" && this.pre_title1_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
              this.hasPreTitle1UrlIcon = true;
            }
        }
      }
  }

  /*
    Retrieves image details of each content layout
  */ 
  getImageDetails():void{
    
    if(this.columnContent[CONSTANTS.IMAGES]!=null && this.columnContent[CONSTANTS.IMAGES].length>0){
      
        this.image_url = this.columnContent[CONSTANTS.IMAGES][0][CONSTANTS.IMAGE_URL];
        this.image_alignment = this.columnContent[CONSTANTS.IMAGES][0][CONSTANTS.IMAGE_ALIGNMENT];
        this.image_caption = this.columnContent[CONSTANTS.IMAGES][0][CONSTANTS.IMAGE_CAPTION];
        this.image_altText = this.columnContent[CONSTANTS.IMAGES][0][CONSTANTS.IMAGE_ALTTEXT];
       
      }
  }

  

  /*
  Retrieves PreTitle2 Details
  */ 
  getPreTitle2Details():void {
    if(this.columnContent[CONSTANTS.PRE_TITLE_2]!=null && this.columnContent[CONSTANTS.PRE_TITLE_2].length>0 ){
      this.preTitle2Present = true;
      this.pre_title2_text = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.TEXT];
      this.pre_title2_url = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.URL];
      this.pre_title2_urlAlt = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.URL_ALT];
      this.pre_title2_target = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.TARGET];
        if(this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.ICON]!= null &&
            this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.ICON].length>0){
            this.pre_title2_iconUrl = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
            this.pre_title2_iconText = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
            this.pre_title2_iconCaption = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
            this.pre_title2_iconAlign = this.columnContent[CONSTANTS.PRE_TITLE_2][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
             if(this.pre_title2_iconUrl != "" && this.pre_title2_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
              this.hasPreTitle2UrlIcon = true;
            }
            
        }
      }
  }

   /*
  Retrieves PostTitle Details
  */
  getPostTitleDetails():void {
    if(this.columnContent[CONSTANTS.POST_TITLE]!=null && this.columnContent[CONSTANTS.POST_TITLE].length>0 ){
      this.postTitlePresent = true;
      this.post_title_text = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.TEXT];
      this.post_title_url = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.URL];
      this.post_title_urlAlt = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.URL_ALT];
      this.post_title_target = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.TARGET];
        if(this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.ICON]!= null &&
            this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.ICON].length>0){
              this.post_title_iconUrl = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
              this.post_title_iconText = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
              this.post_title_iconCaption = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
              this.post_title_iconAlign = this.columnContent[CONSTANTS.POST_TITLE][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
              if(this.post_title_iconUrl != "" && this.post_title_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
                this.hasPostTitleUrlIcon = true;
              }
        }
      }
  }


  /*
  Retrieves Sub Heading Details
  */
  getSubHeadingDetails():void {
    if(this.columnContent[CONSTANTS.SUB_HEADING]!=null && this.columnContent[CONSTANTS.SUB_HEADING].length>0) {
    this.subHeadingPresent = true;
    this.sub_heading_text = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.TEXT];
    this.sub_heading_url = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.URL];
    this.sub_heading_urlAlt = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.URL_ALT];
    this.sub_heading_target = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.TARGET];
      if(this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.ICON]!= null &&
        this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.ICON].length>0){
          this.sub_heading_iconUrl = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
          this.sub_heading_iconText = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
          this.sub_heading_iconCaption = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
          this.sub_heading_iconAlign = this.columnContent[CONSTANTS.SUB_HEADING][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
          if(this.sub_heading_iconUrl != "" && this.sub_heading_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
            this.hasSubHeadingUrlIcon = true;
          }
      }
    }
  }

   /*
  Retrieves Primary Button Details
  */
 getPrimaryButtonDetails():void {
    
  if(this.columnContent[CONSTANTS.PRIMARY_BUTTON]!=null && this.columnContent[CONSTANTS.PRIMARY_BUTTON].length>0 ){
  this.primaryButtonPresent = true;
  this.primary_button_text = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.TEXT];
  this.primary_button_url = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.URL];
  this.primary_button_urlAlt = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.URL_ALT];
  this.primary_button_target = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.TARGET];
    if(this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.ICON]!= null &&
        this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.ICON].length>0){
        this.primary_button_iconUrl = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
        this.primary_button_iconText = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
        this.primary_button_iconCaption = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
        this.primary_button_iconAlign = this.columnContent[CONSTANTS.PRIMARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
        if(this.primary_button_iconUrl != "" && this.primary_button_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
          this.hasPrimaryButtonUrlIcon = true;
        }
    }
  }
}

 /*
Retrieves Secondary Button Details
*/
getSecondaryButtonDetails():void {
  if(this.columnContent[CONSTANTS.SECONDARY_BUTTON]!=null && this.columnContent[CONSTANTS.SECONDARY_BUTTON].length>0 ){
    this.secondaryButtonPresent = true;
    this.secondary_button_text = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.TEXT];
    if(this.retirementLink!=""){
      this.secondary_button_url= this.retirementLink;
    } else{
      this.secondary_button_url = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.URL];
    }
    
    this.secondary_button_urlAlt = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.URL_ALT];
    this.secondary_button_target = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.TARGET];
      if(this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.ICON]!= null &&
          this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.ICON].length>0){
            this.secondary_button_iconUrl = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
            this.secondary_button_iconText = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
            this.secondary_button_iconCaption = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
            this.secondary_button_iconAlign = this.columnContent[CONSTANTS.SECONDARY_BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
            if(this.secondary_button_iconUrl != "" && this.secondary_button_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
              this.hasSecondaryButtonUrlIcon = true;
            }
      }
    }
}


  /*
  Retrieves Primary CTA Details
  */
  getPrimaryCTADetails():void {
    if(this.columnContent[CONSTANTS.PRIMARY_CTA]!=null && this.columnContent[CONSTANTS.PRIMARY_CTA].length>0) {
    this.primaryCTAPresent = true;
    this.primary_CTA_text = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.TEXT];
    this.primary_CTA_url = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.URL];
    this.primary_CTA_urlAlt = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.URL_ALT];
    this.primary_CTA_target = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.TARGET];
      if(this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.ICON]!= null &&
        this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.ICON].length>0){
          this.primary_CTA_iconUrl = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
          this.primary_CTA_iconText = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
          this.primary_CTA_iconCaption = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
          this.primary_CTA_iconAlign = this.columnContent[CONSTANTS.PRIMARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
          if(this.primary_CTA_iconUrl != "" && this.primary_CTA_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
            this.hasPrimaryCTAUrlIcon = true;
          }
      }
    }
  }

  /*
  Retrieves Secondary CTA Details
  */
  getSecondaryCTADetails():void {
    if(this.columnContent[CONSTANTS.SECONDARY_CTA]!=null && this.columnContent[CONSTANTS.SECONDARY_CTA].length>0) {
      this.secondaryCTAPresent = true;
      this.secondary_CTA_text = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.TEXT];
      this.secondary_CTA_url = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.URL];
      this.secondary_CTA_urlAlt = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.URL_ALT];
      this.secondary_CTA_target = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.TARGET];
        if(this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.ICON]!= null &&
          this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.ICON].length>0){
            this.secondary_CTA_iconUrl = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
            this.secondary_CTA_iconText = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
            this.secondary_CTA_iconCaption = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
            this.secondary_CTA_iconAlign = this.columnContent[CONSTANTS.SECONDARY_CTA][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
            if(this.secondary_CTA_iconUrl != "" && this.secondary_CTA_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
              this.hasSecondaryCTAUrlIcon = true;
            }
        }
      }
  }

  
   /*
  Retrieves Buffer Details
  */
  getBufferDetails(): void{

    if(this.columnContent[CONSTANTS.BUFFER_CONTENT]!=null && this.columnContent[CONSTANTS.BUFFER_CONTENT].length>0){
    this.bufferContentPresent = true;
    this.buffer_heading = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.HEADING];
    this.buffer_text = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.TEXT];
    if(this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON]!=null && this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON].length>0) {
      this.bufferContentButtonPresent = true;
      this.buffer_button_text = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.TEXT];
      this.buffer_button_url = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.URL];
      this.buffer_button_urlAlt = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.URL_ALT];
      this.buffer_button_target = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.TARGET];
        if(this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.ICON]!= null &&
          this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.ICON].length>0){
            this.buffer_button_iconUrl = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
            this.buffer_button_iconText = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
            this.buffer_button_iconCaption = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
            this.buffer_button_iconAlign = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.BUTTON][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
            if(this.buffer_button_iconUrl != "" && this.buffer_button_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
              this.hasBufferButtonUrlIcon = true;
            }
        }
      }
      if(this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK]!=null && this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK].length>0) {
        this.bufferContentLinkPresent = true;
        this.buffer_link_text = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.TEXT];
        this.buffer_link_url = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.URL];
        this.buffer_link_urlAlt = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.URL_ALT];
        this.buffer_link_target = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.TARGET];
          if(this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.ICON]!= null &&
            this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.ICON].length>0){
              this.buffer_link_iconUrl = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_URL];
              this.buffer_link_iconText = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALTTEXT];
              this.buffer_link_iconCaption = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_CAPTION];
              this.buffer_link_iconAlign = this.columnContent[CONSTANTS.BUFFER_CONTENT][0][CONSTANTS.LINK][0][CONSTANTS.ICON][0][CONSTANTS.IMAGE_ALIGNMENT];
              if(this.buffer_link_iconUrl != "" && this.buffer_link_iconUrl.startsWith(CONSTANTS.HTTP_URL)){
                this.hasBufferLinkUrlIcon = true;
              }
          }
        }
    }
  }

  /*
    Retrieves image details of each content layout
  */
  chooseThemeForPara(marketingTheme){
    if(this.marketingTheme=='Default'||this.marketingTheme=='Lightest Gray'||this.marketingTheme==''){
      this.paraTheme="prutext-color";
      
    } 
    else if(this.marketingTheme=='Navy'){
      this.paraTheme="graylighter-color";
    }
    else if(this.marketingTheme=='Blue'){
      this.paraTheme="skyblue-color";
    }
  }

   /*
    Retrieves font color for CTA based on marketing slot theme
  */
  chooseThemeForCTA(marketingTheme){
    if(this.marketingTheme=='Default'||this.marketingTheme=='Lightest Gray'||this.marketingTheme==''){
      this.ctaTheme="cta-color";
      
    }
    if(this.marketingTheme=='Navy'||this.marketingTheme=='Blue'){
      this.ctaTheme="pruwhite-color";
    }
  }

   /*
    Retrieves the font color for short title fields based on 
    marketing slot theme
  */
  chooseThemeForShortTitle(marketingTheme){
    if(this.marketingTheme=='Default'||this.marketingTheme=='Lightest Gray'||this.marketingTheme==''){
      this.shortTitleTheme="prublue-color";
      
    }
    if(this.marketingTheme=='Navy'||this.marketingTheme=='Blue'){
      this.shortTitleTheme="gray-color";
    }
  }

  /*
    Retrieves the font color for long title fields based on 
    marketing slot theme
  */
  chooseThemeForLongTitle(marketingTheme){
    if(this.marketingTheme=='Default'||this.marketingTheme=='Lightest Gray'||this.marketingTheme==''){
      this.longTitleTheme="prutext-color";
      
    }
    if(this.marketingTheme=='Navy'||this.marketingTheme=='Blue'){
      this.longTitleTheme="pruwhite-color";
    }
  }

   /*
    Retrieves primary button color based on marketing slot theme
  */
  chooseBtnTypeForPrimary(marketingTheme){
    
    if(this.marketingTheme=='Navy'){
      this.btnTypePrimary="btn-navy";
    }else{
      this.btnTypePrimary="btn-default";
    }
  }

   /*
    Retrieves secondary button color based on marketing slot theme
  */
  chooseBtnTypeForSecondary(marketingTheme){
    
    if(this.marketingTheme=='Blue'){
      this.btnTypeSecondary="btn-blue";
    }else{
      this.btnTypeSecondary="btn-primary";
    }
  }

   /*
    Function to check if any content exists after image
  */
  checkIfContentExistAfterImage():void{
    if(this.preTitle2Present ||  this.short_title_2 != "" || this.long_title_2!= ""
        || this.date != "" || this.readTime != "" || this.author != "" || this.postTitlePresent
          || this.text_1 !="" || this.text_1_para != "" || this.text_2 != ""
             || this.subHeadingPresent || this.sub_text != ""
             || this.primaryButtonPresent || this.secondaryButtonPresent || this.post_text_html != ""
              || this.primaryCTAPresent || this.secondaryCTAPresent || this.bufferContentPresent ) {
                 this.hasContentAfterImage = true;
                 
              }
    }


    //Fire ajax call on click event
    callClickStream(componentName){
  
      setClickStreamPropertiesForClick(event.target,componentName);
    }
}
